import React, { useState, useEffect } from "react";
import { BaseButtons } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import NotificationCard from "./notification-card/NotificationCard";
import KeyMovementNotice from "./key-movement-notice/KeyMovementNotice";
import KeyNoticeTransferNotePopUp from "./key-notice-transfer-note-pop-up/KeyNoticeTransferNotePopUp";

const Notification = ({
  display,
  onCloseClick,
  getUserInvites,
  invitesArray,
  setMessage,
  setLoading,
  setPopUpTitle,
  setToastPop,
  refresh,
  setRefresh,
  auth,
  noticeArray,
}) => {
  const [view, setView] = useState("Pending");
  const [filter, setFilter] = useState("notices");

  const [selectedNotification, setSelectedNotification] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState("");

  const [tranferNote, setTransferNote] = useState("");

  const ClearData = () => {
    setSelectedNotification(null);
    setSelectedAnswer(null);
    setTransferNote("");
  };

  const AnswerInvite = async (inviteId, answer) => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/answerInvites",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: auth.customerUserData.userId,
            email: auth.customerUserData.email,
            inviteId: inviteId,
            answer: answer,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setLoading(false);
        setToastPop(true);
        setMessage("You have accepted invite");
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage("Could not csubmit reply to invite, please contact support");
        setLoading(false);
        setRefresh(refresh ? false : true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "Could not connect check your connection, if this persist contact support"
      );
      setLoading(false);
      setRefresh(refresh ? false : true);
    }
  };

  const AnswerNotification = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/answerNotice",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: auth.customerUserData.userId,

            noticeId: selectedNotification ? selectedNotification._id : "",
            note: tranferNote ? tranferNote : "no notes taken",
            answer: selectedAnswer,
            vehicleId: selectedNotification
              ? selectedNotification.vehicleId
              : "",
            vehicleOwnerId: selectedNotification.vehicleOwnerId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
        ClearData();
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(respnseData.error);
        setLoading(false);
        setRefresh(refresh ? false : true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "Could not connect check your connection, if this persist contact support"
      );
      setLoading(false);
      setRefresh(refresh ? false : true);
    }
  };

  useEffect(() => {
    getUserInvites();
  }, [display]);
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: display ? "100%" : 0,
        transition: "height 0.3s",
        overflowY: display ? "auto" : "hidden",
        overflowX: "hidden",
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div style={{ position: "absolute", top: 20, left: 20 }}>
        <BaseButtons
          label={"BACK"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          height={35}
          onClick={onCloseClick}
          width={70}
        />
      </div>
      <div
        style={{ position: "absolute", top: 20, right: 30, display: "flex" }}
      >
        <BaseButtons
          label={"PENDING"}
          borderRadius={8}
          backgroundColor={
            view === "Pending" ? colors.greenLight : colors.secondaryGrey
          }
          height={35}
          width={110}
          color={view === "Pending" ? colors.white : colors.secondaryDarkBlue}
          onClick={() => setView("Pending")}
        />
        <div style={{ width: 10 }} />
        <BaseButtons
          label={"COMPLETE"}
          borderRadius={8}
          backgroundColor={
            view === "Complete" ? colors.greenLight : colors.secondaryGrey
          }
          height={35}
          onClick={() => setView("Complete")}
          width={110}
          color={view === "Complete" ? colors.white : colors.secondaryDarkBlue}
        />
      </div>
      <div style={{ padding: 35 }} />
      <div
        style={{
          minHeight: 40,
          backgroundColor: colors.greenDark,
          width: "100%",
          display: "flex",
        }}
      >
        {/* <BaseButtons
          width={"33%"}
          label={"MESSAGES"}
          height={"100%"}
          backgroundColor={
            filter === "messages" ? colors.greenDark : colors.greenLight
          }
          onClick={() => setFilter("messages")}
          noShadow={filter === "messages" ? false : true}
        /> */}
        <BaseButtons
          width={"50%"}
          label={"INVITES"}
          height={"100%"}
          backgroundColor={
            filter === "invites" ? colors.greenLight : colors.greenDark
          }
          onClick={() => setFilter("invites")}
          noShadow={filter === "invites" ? false : true}
        />
        <BaseButtons
          width={"50%"}
          label={"NOTICES"}
          height={"100%"}
          backgroundColor={
            filter === "notices" ? colors.greenLight : colors.greenDark
          }
          onClick={() => setFilter("notices")}
          noShadow={filter === "notices" ? false : true}
        />
      </div>
      {filter === "invites" ? (
        <>
          {view === "Pending"
            ? invitesArray
              ? invitesArray.map((invite, index) => {
                  return invite.status === "Pending" ? (
                    <div key={index} style={{ width: "100%" }}>
                      <NotificationCard
                        status={invite.status}
                        title={invite.linkedBrand}
                        description={
                          invite.message
                            ? invite.message
                            : "You have been invited by " +
                              " " +
                              invite.createdBy +
                              ", as a " +
                              " " +
                              invite.roles[0] +
                              " User, if you recognise this request and have shared your link pin with them please accept.."
                        }
                        onAcceptClick={() =>
                          AnswerInvite(invite._id, "ACCEPTED")
                        }
                        onDeclineClick={() =>
                          AnswerInvite(invite._id, "DECLINED")
                        }
                      />
                    </div>
                  ) : null;
                })
              : null
            : null}
          {view === "Complete"
            ? invitesArray
              ? invitesArray.map((invite, index) => {
                  return invite.status !== "Pending" ? (
                    <div key={index} style={{ width: "100%" }}>
                      <NotificationCard
                        title={invite.linkedBrand}
                        status={invite.status}
                        description={
                          "You have been invited by " +
                          " " +
                          invite.createdBy +
                          ", as a " +
                          " " +
                          invite.roles[0] +
                          " User, if you recognise this request and have shared your link pin with them please accept.."
                        }
                      />
                    </div>
                  ) : null;
                })
              : null
            : null}
        </>
      ) : null}
      {filter === "notices" ? (
        <>
          {noticeArray.length >= 1
            ? noticeArray.map((notice, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    {notice ? (
                      notice.type === "KEY MOVEMENT" ? (
                        <KeyMovementNotice
                          notice={notice}
                          onAcceptClick={() => {
                            setSelectedAnswer("ACCEPTED");
                            setSelectedNotification(notice);
                          }}
                          onDeclineClick={() => {
                            setSelectedAnswer("DECLINED");
                            setSelectedNotification(notice);
                          }}
                        />
                      ) : null
                    ) : null}
                  </div>
                );
              })
            : null}
        </>
      ) : null}
      <div style={{ padding: 60 }} />
      <KeyNoticeTransferNotePopUp
        display={selectedNotification}
        selectedNotice={selectedNotification}
        onCancelClick={() => ClearData()}
        selectedAnswer={selectedAnswer}
        onNoteChange={(e) => setTransferNote(e.target.value)}
        noteValue={tranferNote}
        onSubmitClick={() => AnswerNotification()}
      />
    </div>
  );
};

export default Notification;
